import Vue from 'vue'

export default {
  ADD_NEW_PUBLICATION (state, publication) {
    state.publications.push(publication)
    state.publication = publication
  },
  DELETE_PUBLICATION (state, id) {
    state.publications = state.publications.filter(p => p.id !== id)
  },
  UPDATE_PUBLICATION (state, publication) {
    state.publication = publication
  },
  ADD_PUBLICATIONS (state, publications) {
    state.publications = publications
  },
  ADD_PUBLICATION (state, publication) {
    state.publication = publication
  },
  ADD_PUBLICATION_PHOTO (state, publication) {
    Vue.set(state.publication, 'photo', publication.photo)
  },
  DELETE_PUBLICATION_PHOTO (state) {
    Vue.set(state.publication, 'photo', '')
  },
  DELETE_ABOUT_PHOTO (state) {
    Vue.set(state.settings, 'aboutGrottbjornPhoto', '')
  },
  ADD_ABOUT_PHOTO (state, settings) {
    Vue.set(state.settings, 'aboutGrottbjornPhoto', settings.aboutGrottbjornPhoto)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/publications.js